import React from 'react';
import { Image } from 'react-bootstrap';

const Logo = ({ small = false, height, isYellow = false }) => {
  if (isYellow) {
    return <Image src={`${process.env.PUBLIC_URL}/logo_yellow_transparent.png`} height={height || (small ? 30 : 50)} />;
  }
  return <Image src={`${process.env.PUBLIC_URL}/logo_transparent.png`} height={height || (small ? 30 : 50)} />;
};

export default Logo;
